import { Action, createReducer, on } from '@ngrx/store';
import { cloneDeep, defaultsDeep, keys, map, toInteger } from 'lodash';

import { PortalConfigDefinition, Role } from '@lockton-apps/shared/interfaces';
import { STATIC_PORTAL_CONFIG } from '@lockton-apps/shared/util/constants';

import * as PortalConfigActions from './portal-config.actions';

export const PORTAL_CONFIG_FEATURE_KEY = 'portal-config';

export interface PortalConfigState {
  config: PortalConfigDefinition;
  userConfigIds?: number[];
  activePortalId?: number | null;
  loaded: boolean; // has the PortalConfig list been loaded
  error?: string | null; // last known error (if any)
}

export interface PortalConfigPartialState {
  readonly [PORTAL_CONFIG_FEATURE_KEY]: PortalConfigState;
}

export const initialPortalConfigState: PortalConfigState = {
  // set initial required properties
  config: STATIC_PORTAL_CONFIG,
  loaded: false,
};

const reducer = createReducer(
  initialPortalConfigState,
  on(
    PortalConfigActions.loadPortalConfigSuccess,
    (state, { portalConfig, role }) => {
      const userConfigIds = map(keys(portalConfig), toInteger);
      return {
        ...state,
        config: defaultsDeep(cloneDeep(state.config), portalConfig),
        // userConfigIds: [1, 3],
        userConfigIds,
        loaded: true,
        activePortalId:
          role === Role.Administrator
            ? null
            : userConfigIds.length === 0
              ? null
              : userConfigIds[0],
      };
    },
  ),
  on(PortalConfigActions.portalSelected, (state, { portalId }) => ({
    ...state,
    activePortalId: portalId,
  })),
  on(PortalConfigActions.loadPortalConfigFailure, (state, { error }) => ({
    ...state,
    error,
  })),
);

export function portalConfigReducer(
  state: PortalConfigState | undefined,
  action: Action,
) {
  return reducer(state, action);
}
